import StoryletService from 'services/StoryletService';

export default function beginGateEvent(eventId: number) {
  return async () => new StoryletService().begin(eventId);
}